@if (subscriptionPlanQuotas()[quotaType()]; as quota) {
  <div class="flex justify-between">
    <span class="flex items-center font-semibold">
      <sb-icon
        class="mr-sm"
        [class.text-success]="quota.usage <= quota.limit"
        [class.text-danger]="quota.usage > quota.limit"
        [size]="'lg'"
        [name]="quota.usage > quota.limit ? 'times-circle' : 'check-circle'"
      />
      @switch (quotaType()) {
        @case (quotaTypes.DEPARTMENTS) {
          {{ 'Department limit' | translate }}
        }
        @case (quotaTypes.TEAMS) {
          {{ 'Team limit' | translate }}
        }
        @case (quotaTypes.SEATS) {
          {{ 'Employee limit' | translate }}
        }
      }
    </span>
    <sb-badge [color]="quota.usage > quota.limit ? 'red' : 'green'"> {{ quota.usage }}/{{ quota.limit }} </sb-badge>
  </div>
}
